import { Box, Button, Stack, Typography } from '@mui/material';
import { Undo2 } from 'lucide-react';
import { formatHumanDateTime } from '../helpers/dateTime';
import RequestChangeComparison from './RequestChangeComparison';

function personLabel(nombre, apellido, email) {
  return [[nombre, apellido].filter(Boolean).join(' '), email].filter(Boolean).join(' · ') || 'No registrado';
}

export default function PendingRequestDetails({ request, showUser = true, onCancelRequest, cancelling = false }) {
  const location = [request.pais, request.iglesiaEstado, request.iglesiaCiudad, request.iglesiaNombre]
    .filter(Boolean).join(' / ');
  return (
    <Stack spacing={1.25} sx={{ minWidth: 0 }}>
      <Stack spacing={0.25} sx={{ overflowWrap: 'anywhere' }}>
        {showUser && <Typography variant="body2"><strong>Usuario:</strong> {personLabel(request.usuarioNombre, request.usuarioApellido, request.usuarioEmail)}</Typography>}
        {location && <Typography variant="body2"><strong>Sede:</strong> {location}</Typography>}
        <Typography variant="body2" color="text.secondary"><strong>Solicitado por:</strong> {personLabel(request.solicitadoPorNombre, request.solicitadoPorApellido, request.solicitadoPorEmail)}</Typography>
        <Typography variant="body2" color="text.secondary"><strong>Fecha:</strong> {formatHumanDateTime(request.fecha, request.fecha || 'No registrada')}</Typography>
      </Stack>
      {Array.isArray(request.changes) && request.changes.length > 0 ? (
        <RequestChangeComparison entries={request.changes} />
      ) : request.detalle ? (
        <Box>
          <Typography variant="subtitle2">Detalle de la solicitud</Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', whiteSpace: 'pre-line', overflowWrap: 'anywhere' }}>{request.detalle}</Typography>
        </Box>
      ) : (
        <Typography variant="body2" color="text.secondary">No hay detalles registrados.</Typography>
      )}
      {request.note && <Box>
        <Typography variant="subtitle2">Nota</Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', whiteSpace: 'pre-line', overflowWrap: 'anywhere' }}>{request.note}</Typography>
      </Box>}
      {onCancelRequest && (
        <Box>
          <Button
            type="button"
            variant="outlined"
            color="error"
            startIcon={<Undo2 size={16} />}
            disabled={cancelling}
            onClick={() => onCancelRequest(request)}
          >
            Cancelar cambios
          </Button>
        </Box>
      )}
    </Stack>
  );
}
